import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import SearchIcon from "@material-ui/icons/Search";
import SunnyIcon from "@material-ui/icons/WbSunny";
import React, { useState } from "react";
import { languages } from "../../constants/languages";
import CreateFeatureContainer from "../../containers/features/CreateFeatureContainer";
import { FeaturesHeader } from "./FeaturesHeader";
import FeaturesList from "./FeaturesList";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    maxWidth: 800,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 56,
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  controls: {
    display: "flex",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      gap: theme.spacing(2),
    },
  },
  searchField: {
    flexGrow: 1,
    width: "100%",
  },
  selectsContainer: {
    display: "flex",
    flexGrow: 1,
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  sortSelect: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      flex: 1,
    },
  },
  infoBox: {
    background: "rgb(236, 239, 241)",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    marginRight: theme.spacing(1),
    fontSize: 19,
  },
}));

export const Features = (props) => {
  const classes = useStyles();
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("newest");
  const [filterBy, setFilterBy] = useState("all");

  const filterAndSortFeatures = (features) => {
    // First filter by status
    let filtered = features.filter((feature) => {
      switch (filterBy) {
        case "open":
          return !feature.done;
        case "implemented":
          return feature.done;
        default: // "all"
          return true;
      }
    });

    // Then filter by search query
    filtered = filtered.filter((feature) =>
      feature.ideaString.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (sortBy === "newest") {
      return filtered.sort((a, b) => b.date - a.date);
    }
    return filtered;
  };

  return (
    <div>
      <FeaturesHeader
        user={props.user}
        userData={props.userData}
        handleBackClick={props.handleBackClick}
      />
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography variant="h6">{languages.features.title}</Typography>
          <CreateFeatureContainer user={props.user} />
        </div>

        <div className={classes.controls}>
          <TextField
            className={classes.searchField}
            placeholder={`${languages.general.search}...`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          <div className={classes.selectsContainer}>
            <FormControl className={classes.sortSelect}>
              <Select
                value={filterBy}
                onChange={(e) => setFilterBy(e.target.value)}
                displayEmpty
              >
                <MenuItem value="all">
                  {languages.features.allRequests}
                </MenuItem>
                <MenuItem value="open">
                  {languages.features.openRequests}
                </MenuItem>
                <MenuItem value="implemented">
                  {languages.features.implementedRequests}
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl className={classes.sortSelect}>
              <Select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                displayEmpty
              >
                <MenuItem value="newest">{languages.features.newest}</MenuItem>
                <MenuItem value="most_votes">
                  {languages.features.mostUpvotes}
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className={classes.infoBox}>
          <SunnyIcon className={classes.infoIcon} />
          {languages.features.info}
        </div>

        <FeaturesList
          features={filterAndSortFeatures(props.features)}
          handleFeatureClick={props.handleFeatureClick}
          sortBy={sortBy}
        />
      </div>
    </div>
  );
};
